import React, { Component } from "react";
import MobileSlider from '../../components/home-good-company-slider/mobile-slider';
import DeskTopSlider from '../../components/home-good-company-slider/desktop-slider';
class GoodCompany extends Component{

	constructor(props){
		super(props);
		this.state={
			changeView:false,
		}
	}

	componentDidMount(){
			window.innerWidth<=1100 ? this.setState({changeView:true}) : this.setState({changeView:false});
			this.setOnResize();
	}

	setOnResize=()=>{
		window.addEventListener('resize',()=>{
			window.innerWidth<=1100 ? this.setState({changeView:true}) : this.setState({changeView:false});
		})
	}



	render() {
		return (
			<section className="good-company" style={{backgroundImage: `url(images/good-company.jpg)`}}>
				 <div className="top-shape"></div>
    <div className="bottom-shape"></div>

  <div className="rounded-top-right-corner"></div>

  <div className="rounded-bottom-left-corner"></div>

  <div className="rounded-bottom-right-corner"></div>
				  <div className="container animate-fade">
					    <h2>You're in good company</h2>
					    <p>Over 1 million Content Creators large and small are earning with Webtalk Rewards </p>
					   	{this.state.changeView ? <MobileSlider/> : <DeskTopSlider/>}
				  </div>
			</section>
		);
	}

}

export default GoodCompany;